module.exports = __webpack_public_path__ + "static/f2_large-6b441c2647ed6b7e874bcb284a5b5dfd.jpg";